import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71L12 2z"
}), 'NavigationSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/NavigationSharp.js
// module id = 5004
// module chunks = 2